import { GridRowParams } from '@material-ui/data-grid';
import React, { useState, useEffect, ChangeEvent, useCallback } from 'react';

import { toast } from 'react-toastify';
import { GiPlug } from 'react-icons/gi';
import { GoPencil } from 'react-icons/go';
import { FiPlusCircle } from 'react-icons/fi';
import CircularProgress from '@material-ui/core/CircularProgress';
import api from '~/services/api';
import Search from '~/components/Search';
import { Container, FieldWrapper, ToggleEye } from './styles';
import FormDefault from '~/components/FormDefault';

import {
  IFormConfiguracaoEmail,
  ISelect,
  IEmailServidorEntrada,
  ISmtp,
} from './types';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import ModalEmailServidorEntrada from './ModalEmailServidorEntrada';
import ModalSmtp from './ModalSmtp';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { Col } from 'react-bootstrap';
import { InputSelect, InputText } from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';

const ConfiguracaoDeEmail: React.FC = () => {
  /**
   *  Campos Gerais
   */
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [modalEmailServidorEntrada, setModalEmailServidorEntrada] =
    useState(false);
  const [modalSmtp, setModalSmtp] = useState(false);
  const [idEmailServidorEntrada, setIdEmailServidorEntrada] = useState(0);
  const [idSmtp, setIdSmtp] = useState(0);
  const [emailsServidoresEntrada, setEmailsServidoresEntrada] = useState<
    ISelect[]
  >([]);
  const [smtps, setSmtps] = useState<ISelect[]>([]);
  const [emailServidorEntradaIsLoading, setEmailServidorEntradaIsLoading] =
    useState(false);
  const [smtpIsLoading, setSmtpIsLoading] = useState(false);

  const [formConfiguracaoEmail, setFormConfiguracaoEmail] =
    useState<IFormConfiguracaoEmail>({
      cod_email: {
        value: undefined,
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      des_nome: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      cod_servidor_entrada: {
        value: { label: 'Nenhum', value: undefined },
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_email_entrada: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_senha_entrada: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      cod_smtp: {
        value: { label: 'Nenhum', value: undefined },
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_email: {
        value: '',
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      des_senha: {
        value: '',
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      flg_configuracao_entrada: {
        value: true,
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
    });

  const {
    register,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswords = () => {
    setShowPasswords(!showPasswords);
  };

  useEffect(() => {
    getEmailsServidoresEntrada();
    getSmtps();
  }, []);

  useEffect(() => {
    if (!modalSmtp) {
      setIdSmtp(0);
      getSmtps();
    }
    if (!modalEmailServidorEntrada) {
      setIdEmailServidorEntrada(0);
      getEmailsServidoresEntrada();
    }
  }, [modalEmailServidorEntrada, modalSmtp]);

  async function getEmailsServidoresEntrada() {
    try {
      const res = await api.get('/email-servidor-entrada');
      const { success, data, message } = res.data;
      if (!success) throw new Error(message);
      const regs = data.map((item: IEmailServidorEntrada) => {
        return {
          label: `${item.des_servidor}:${item.num_porta}`,
          value: item.cod_servidor,
        };
      });
      const regsOrder = regs.sort((a: any, b: any) => {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      regs.unshift({
        value: 0,
        label: 'Nenhum',
      });
      setEmailsServidoresEntrada(regsOrder);
    } catch (e: any) {
      toast.warning(e.message);
    }
  }
  async function getSmtps() {
    try {
      const res = await api.get('/smtp');
      const { success, data, message } = res.data;
      if (!success) throw new Error(message);
      const regs = data.map((item: ISmtp) => {
        return {
          label: `${item.des_smtp}:${item.num_porta}`,
          value: item.cod_smtp,
        };
      });
      const regsOrder = regs.sort((a: any, b: any) => {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      regs.unshift({
        value: 0,
        label: 'Nenhum',
      });
      setSmtps(regsOrder);
    } catch (e: any) {
      toast.warning(e.message);
    }
  }

  const onRowClick = async (param: GridRowParams) => {
    try {
      const { cod_email } = param.row;

      const res = await api.get(`/email/${cod_email}`);
      const { success, data, message } = res.data;
      if (!success) throw new Error(message);

      const {
        des_nome,
        cod_servidor_entrada,
        des_email_entrada,
        des_senha_entrada,
        cod_smtp,
        des_email,
        des_senha,
        flg_configuracao_entrada,
      } = data;

      setValue('des_nome', des_nome);

      const emailEntradaSelected = (emailsServidoresEntrada || []).find(
        (e) => Number(e.value) === Number(cod_servidor_entrada),
      );
      const emailEntrada = emailEntradaSelected
        ? {
            value: emailEntradaSelected.value,
            label: emailEntradaSelected.label,
          }
        : {
            value: undefined,
            label: 'Selecione ou cadastre um novo IMAP/POP3',
          };
      setValue('cod_servidor_entrada', emailEntrada);

      setValue('des_email_entrada', des_email_entrada);

      const smtpSelected = (smtps || []).find(
        (e) => Number(e.value) === Number(cod_smtp),
      );
      const smtp = smtpSelected
        ? {
            value: smtpSelected.value,
            label: smtpSelected.label,
          }
        : { value: undefined, label: 'Selecione ou cadastre um novo SMTP' };
      setValue('cod_smtp', smtp);

      setValue('des_email', des_email);

      setFormConfiguracaoEmail({
        cod_email: {
          ...formConfiguracaoEmail.cod_email,
          value: cod_email,
          isInvalid: false,
        },
        des_nome: {
          ...formConfiguracaoEmail.des_nome,
          value: des_nome,
          isInvalid: false,
        },
        cod_servidor_entrada: {
          ...formConfiguracaoEmail.cod_servidor_entrada,
          value: { label: 'Nenhum', value: cod_servidor_entrada },
          isInvalid: false,
        },
        des_email_entrada: {
          ...formConfiguracaoEmail.des_email_entrada,
          value: des_email_entrada,
          isInvalid: false,
        },
        des_senha_entrada: {
          ...formConfiguracaoEmail.des_senha_entrada,
          value: des_senha_entrada,
          isInvalid: false,
        },
        cod_smtp: {
          ...formConfiguracaoEmail.cod_smtp,
          value: { label: 'Nenhum', value: cod_smtp },
          isInvalid: false,
        },
        des_email: {
          ...formConfiguracaoEmail.des_email,
          value: des_email,
          isInvalid: false,
        },
        des_senha: {
          ...formConfiguracaoEmail.des_senha,
          value: des_senha,
          isInvalid: false,
        },
        flg_configuracao_entrada: {
          ...formConfiguracaoEmail.flg_configuracao_entrada,
          value: flg_configuracao_entrada,
        },
      });
      setIsUpdate(true);
      setShowSearch(false);
    } catch (e: any) {
      toast.warning(e.message);
    }
  };

  function validaFormConfiguracaoEmail(
    inputs: IFormConfiguracaoEmail,
  ): boolean {
    for (let i = 0; i < Object.keys(inputs).length; i++) {
      if (
        formConfiguracaoEmail[
          Object.keys(inputs)[i] as keyof IFormConfiguracaoEmail
        ].isRequired &&
        formConfiguracaoEmail[
          Object.keys(inputs)[i] as keyof IFormConfiguracaoEmail
        ].isInvalid
      ) {
        return true;
      }
    }
    return false;
  }

  const handleSubmit = useCallback(async () => {
    const arr = isUpdate
      ? [
          'des_nome',
          'cod_servidor_entrada',
          'des_email_entrada',
          'cod_smtp',
          'des_email',
        ]
      : [
          'des_nome',
          'cod_servidor_entrada',
          'des_email_entrada',
          'des_senha_entrada',
          'cod_smtp',
          'des_email',
          'des_senha',
        ];

    arr.forEach((field) => {
      if (
        (typeof getValues(field) === 'string' && getValues(field) === '') ||
        (typeof getValues(field) !== 'string' &&
          getValues(field)?.label === 'Nenhum')
      ) {
        setError(field, { type: 'required' });
      }
    });

    if (!validaEmail(formConfiguracaoEmail.des_email_entrada.value)) {
      setFormConfiguracaoEmail({
        ...formConfiguracaoEmail,
        des_email_entrada: {
          ...formConfiguracaoEmail.des_email_entrada,
          isInvalid: true,
        },
      });

      return toast.warning('[Servidor de Entrada] E-mail inválido.');
    }
    if (!formConfiguracaoEmail.flg_configuracao_entrada.value) {
      if (!validaEmail(formConfiguracaoEmail.des_email.value)) {
        setFormConfiguracaoEmail({
          ...formConfiguracaoEmail,
          des_email: {
            ...formConfiguracaoEmail.des_email,
            isInvalid: true,
          },
        });

        return toast.warning('[SMTP] E-mail inválido.');
      }
    }
    if (validaFormConfiguracaoEmail(formConfiguracaoEmail)) {
      toast.warning('Há informações pendentes.');
      return;
    }

    try {
      const upsert = {
        des_nome: formConfiguracaoEmail.des_nome.value,
        cod_servidor_entrada:
          formConfiguracaoEmail.cod_servidor_entrada.value.value,
        des_email_entrada: formConfiguracaoEmail.des_email_entrada.value,
        des_senha_entrada: formConfiguracaoEmail.des_senha_entrada.value,
        cod_smtp: formConfiguracaoEmail.cod_smtp.value.value,
        des_email: formConfiguracaoEmail.flg_configuracao_entrada.value
          ? formConfiguracaoEmail.des_email_entrada.value
          : formConfiguracaoEmail.des_email.value,
        des_senha: formConfiguracaoEmail.flg_configuracao_entrada.value
          ? formConfiguracaoEmail.des_senha_entrada.value
          : formConfiguracaoEmail.des_senha.value,
        flg_configuracao_entrada:
          formConfiguracaoEmail.flg_configuracao_entrada.value,
      };

      if (!isUpdate) {
        const res = await api.post('/email', upsert);
        const { success, message } = res.data;
        if (!success) throw new Error(message);
        setShowSearch(false);
        onClearForm();
        return toast.success(message);
      }

      const res = await api.put(
        `/email/${formConfiguracaoEmail.cod_email.value}`,
        upsert,
      );
      const { success, message } = res.data;
      if (!success) throw new Error(message);
      setShowSearch(true);
      onClearForm();
      return toast.success(message);
    } catch (e: any) {
      toast.warning(e.message);
    }
  }, [formConfiguracaoEmail]);

  function validaEmail(email: string): boolean {
    const regMail =
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regMail.test(email)) {
      toast.warning(
        '[IMAP] E-mail inválido. O email deve conter @ e um domínio válido.',
      );
    }
    return regMail.test(email);
  }

  async function testConfigEmailServidorEntrada() {
    setEmailServidorEntradaIsLoading(true);
    if (!formConfiguracaoEmail.cod_servidor_entrada.value.value) {
      setEmailServidorEntradaIsLoading(false);
      return toast.warning('[Servidor de Entrada] Selecione um servidor.');
    }
    if (formConfiguracaoEmail.des_email_entrada.value === '') {
      setEmailServidorEntradaIsLoading(false);
      return toast.warning(
        '[Servidor de Entrada] Defina o e-mail para efetuar o teste.',
      );
    }

    if (!validaEmail(formConfiguracaoEmail.des_email_entrada.value)) {
      setEmailServidorEntradaIsLoading(false);
      return toast.warning('[Servidor de Entrada] E-mail inválido.');
    }
    try {
      const test = {
        cod_email: formConfiguracaoEmail.cod_email.value || undefined,
        des_email_entrada: formConfiguracaoEmail.des_email_entrada.value,
        des_senha_entrada: formConfiguracaoEmail.des_senha_entrada.value,
        cod_servidor_entrada:
          formConfiguracaoEmail.cod_servidor_entrada.value.value,
      };

      const res = await api.post('/email/test/email-servidor-entrada', test);
      const { message } = res.data;
      toast.success(message);
    } finally {
      setEmailServidorEntradaIsLoading(false);
    }
  }

  async function testConfigSMTP() {
    if (!formConfiguracaoEmail.cod_smtp.value.value) {
      return toast.warning('[SMTP] Selecione um servidor SMTP.');
    }
    if (!formConfiguracaoEmail.flg_configuracao_entrada.value) {
      if (formConfiguracaoEmail.des_email.value === '') {
        return toast.warning('[SMTP] Defina o e-mail para efetuar o teste.');
      }

      if (!validaEmail(formConfiguracaoEmail.des_email.value)) {
        return toast.warning('[SMTP] E-mail inválido.');
      }
    } else {
      if (formConfiguracaoEmail.des_email_entrada.value === '') {
        return toast.warning(
          '[Servidor de Entrada] Defina o e-mail para efetuar o teste.',
        );
      }

      if (!validaEmail(formConfiguracaoEmail.des_email_entrada.value)) {
        return toast.warning('[Servidor de Entrada] E-mail inválido.');
      }
    }
    try {
      setSmtpIsLoading(true);
      const test = {
        cod_email: formConfiguracaoEmail.cod_email.value || undefined,
        des_email: !formConfiguracaoEmail.flg_configuracao_entrada.value
          ? formConfiguracaoEmail.des_email.value
          : formConfiguracaoEmail.des_email_entrada.value,
        des_senha: !formConfiguracaoEmail.flg_configuracao_entrada.value
          ? formConfiguracaoEmail.des_senha.value
          : formConfiguracaoEmail.des_senha_entrada.value,
        cod_smtp: formConfiguracaoEmail.cod_smtp.value.value,
        flg_configuracao_entrada:
          formConfiguracaoEmail.flg_configuracao_entrada.value,
      };
      const res = await api.post('/email/test/smtp', test);
      const { message } = res.data;
      toast.success(message);
    } finally {
      setSmtpIsLoading(false);
    }
  }

  function handleModalEmailServidorEntrada(id?: number) {
    if (id) {
      setIdEmailServidorEntrada(id);
    }
    setModalEmailServidorEntrada(true);
  }

  function handleModalSmtp(id?: number) {
    if (id) {
      setIdSmtp(id);
    }
    setModalSmtp(true);
  }

  async function onDelete() {
    try {
      const res = await api.delete(
        `/email/${formConfiguracaoEmail.cod_email.value}`,
      );
      const { success, message } = res.data;
      if (!success) {
        throw new Error(message);
      }
      setShowSearch(true);
      onClearForm();
      toast.success(message);
      // MySwal.fire({
      //   text: message,
      //   icon: 'success',
      //   showConfirmButton: false,
      // });
    } catch (error: any) {
      toast.warning(error.message);
    }
  }

  const onNewData = async () => {
    onClearForm();
    setShowSearch(false);
    setIsUpdate(false);
  };

  async function onCancel() {
    setIsUpdate(false);
    onClearForm();
    setShowSearch(true);
  }

  function onClearForm() {
    setValue('des_nome', '');
    setValue('cod_servidor_entrada', {
      label: 'Selecione ou cadastre um novo IMAP/POP3',
      value: 0,
    });
    setValue('des_email_entrada', '');
    setValue('des_senha_entrada', '');
    setValue('cod_smtp', {
      label: 'Selecione ou cadastre um novo SMTP',
      value: 0,
    });
    setValue('des_email', '');
    setValue('des_senha', '');

    const arr = isUpdate
      ? [
          'des_nome',
          'cod_servidor_entrada',
          'des_email_entrada',
          'cod_smtp',
          'des_email',
        ]
      : [
          'des_nome',
          'cod_servidor_entrada',
          'des_email_entrada',
          'des_senha_entrada',
          'cod_smtp',
          'des_email',
          'des_senha',
        ];

    arr.forEach((field) => {
      if (
        (typeof getValues(field) === 'string' && getValues(field) === '') ||
        (typeof getValues(field) !== 'string' &&
          getValues(field)?.label === 'Nenhum')
      ) {
        clearErrors(field);
      }
    });

    setFormConfiguracaoEmail({
      cod_email: {
        value: undefined,
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      des_nome: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      cod_servidor_entrada: {
        value: { label: 'Nenhum', value: undefined },
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_email_entrada: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_senha_entrada: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      cod_smtp: {
        value: { label: 'Nenhum', value: undefined },
        isInvalid: true,
        isRequired: true,
        invalidLabel: undefined,
      },
      des_email: {
        value: '',
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      des_senha: {
        value: '',
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
      flg_configuracao_entrada: {
        value: false,
        isInvalid: false,
        isRequired: false,
        invalidLabel: undefined,
      },
    });

    setIsUpdate(false);
    setShowPassword(false);
    setShowPasswords(false);
  }

  const tst = async (value: any) => {
    const res = await api.get('/email-servidor-entrada');
    const { success, data, message } = res.data;
    if (success) {
      const tsts = data.find((item: ISelect) => {
        return item.des_servidor === value.des_servidor;
      });

      setFormConfiguracaoEmail({
        ...formConfiguracaoEmail,
        cod_servidor_entrada: {
          ...formConfiguracaoEmail.cod_servidor_entrada,
          value: {
            label: `${tsts.des_servidor}:${tsts.num_porta}`,
            value: tsts.cod_servidor,
          },
          isInvalid: false,
        },
      });
    }
  };

  const tex = async (value: any) => {
    const res = await api.get('/smtp');
    const { success, data, message } = res.data;
    if (success) {
      const text = data.find((item: ISelect) => {
        return item.des_smtp === value.des_smtp;
      });
      setFormConfiguracaoEmail({
        ...formConfiguracaoEmail,
        cod_smtp: {
          ...formConfiguracaoEmail.cod_smtp,
          value: { label: '', value: text.cod_smtp },
          isInvalid: false,
        },
      });
    }
  };

  return (
    <>
      <ModalEmailServidorEntrada
        show={modalEmailServidorEntrada}
        handleShow={setModalEmailServidorEntrada}
        handleTest={tst}
        id={idEmailServidorEntrada}
      />
      <Container>
        <ModalSmtp
          show={modalSmtp}
          handleShow={setModalSmtp}
          handleTex={tex}
          id={idSmtp}
        />

        {showSearch && (
          <Search codTela={50} newData={onNewData} onRowClick={onRowClick} />
        )}
        {!showSearch && (
          <FormDefault
            codTela={50}
            title="Configuração de E-mail"
            codigoRegistro={[
              {
                value: formConfiguracaoEmail.cod_email.value,
                des_campo: 'Código do Registro',
              },
            ]}
            onSave={async () => {
              await handleSubmit();
            }}
            onCancel={onCancel}
            isUpdate={isUpdate}
            onNew={onNewData}
            onDelete={onDelete}
            onClearFields={onClearForm}
            onReturnSearch={onCancel}
          >
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12">
                <InputText
                  label="Nome"
                  placeholder="Digite aqui o nome"
                  maxLength={50}
                  control={control}
                  name="des_nome"
                  register={register}
                  isError={!!errors.des_nome}
                  onInput={(ev: any) => {
                    const input = ev.target;
                    const start = input.selectionStart ?? input.value.length;
                    const end = input.selectionEnd ?? input.value.length;

                    // apenas UPPERCASE enquanto digita
                    const upper = input.value.toUpperCase();

                    setValue('des_nome', upper, { shouldDirty: true });
                    setFormConfiguracaoEmail((prev) => ({
                      ...prev,
                      des_nome: {
                        ...prev.des_nome,
                        value: upper,
                        isInvalid: upper.trim() === '',
                      },
                    }));

                    // restaura a posição do cursor
                    requestAnimationFrame(() => {
                      try {
                        input.setSelectionRange(start, end);
                      } catch {
                        /* input pode não estar montado; ignore */
                      }
                    });
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-12">
                <Separator labelText="Servidor de Entrada" />
              </div>
            </div>
            <Col sm={12} md={12}>
              <div className="row d-flex align-items-center">
                <div className="col-sm-12 col-md-11">
                  <InputSelect
                    options={emailsServidoresEntrada as any[]}
                    label="IMAP/POP3"
                    placeholder="Selecione ou cadastre um novo IMAP/POP3"
                    control={control}
                    name="cod_servidor_entrada"
                    register={register}
                    isError={!!errors.cod_servidor_entrada}
                    changeSelected={(selected: any) => {
                      const value = {
                        label: selected?.label || 'Nenhum',
                        value: selected?.value || 0,
                      };

                      setValue('cod_servidor_entrada', value);

                      setFormConfiguracaoEmail({
                        ...formConfiguracaoEmail,
                        cod_servidor_entrada: {
                          ...formConfiguracaoEmail.cod_servidor_entrada,
                          value,
                          isInvalid: value.value === undefined,
                        },
                      });
                    }}
                  />
                </div>

                <div className="col-sm-12 col-md-1 d-flex align-items-center justify-content-center gap-4 mt-4">
                  <button
                    type="button"
                    className="btn-actions"
                    onClick={() => handleModalEmailServidorEntrada()}
                  >
                    <FiPlusCircle size={24} color="#309063" />
                  </button>
                  {formConfiguracaoEmail.cod_servidor_entrada?.value?.value &&
                  formConfiguracaoEmail.cod_servidor_entrada.value.value !==
                    0 ? (
                    <button
                      type="button"
                      className="btn-actions"
                      onClick={() =>
                        handleModalEmailServidorEntrada(
                          formConfiguracaoEmail.cod_servidor_entrada.value
                            .value,
                        )
                      }
                    >
                      <GoPencil size={24} color="#4c9aff" />
                    </button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Col>
            <div className="row">
              <div className="col-sm-12 col-md-5">
                <InputText
                  label="Email"
                  type="email"
                  placeholder="Digite aqui o email"
                  maxLength={100}
                  control={control}
                  register={register}
                  name="des_email_entrada"
                  isError={!!errors.des_email_entrada}
                  onInput={(ev: any) => {
                    const { value } = ev.target;

                    setValue('des_email_entrada', value);

                    if (formConfiguracaoEmail.flg_configuracao_entrada.value) {
                      setValue('des_email', value);
                      setFormConfiguracaoEmail({
                        ...formConfiguracaoEmail,
                        des_email: {
                          ...formConfiguracaoEmail.des_email,
                          value,
                          isInvalid: value === '',
                        },
                      });
                    }

                    setFormConfiguracaoEmail({
                      ...formConfiguracaoEmail,
                      des_email_entrada: {
                        ...formConfiguracaoEmail.des_email_entrada,
                        value,
                        isInvalid: value === '',
                      },
                    });
                  }}
                />
              </div>

              <div className="col-sm-12 col-md-5">
                <FieldWrapper>
                  <InputText
                    name="des_senha_entrada"
                    control={control}
                    register={register}
                    isError={!!errors.des_senha_entrada}
                    label="Senha"
                    type={showPassword ? 'text' : 'password'}
                    placeholder={isUpdate ? '' : 'Digite aqui a senha'}
                    maxLength={50}
                    onInput={(e: ChangeEvent<HTMLInputElement>) => {
                      const { value } = e.target;

                      setValue('des_senha_entrada', value);

                      if (
                        formConfiguracaoEmail.flg_configuracao_entrada.value
                      ) {
                        setValue('des_senha', value);
                        setFormConfiguracaoEmail({
                          ...formConfiguracaoEmail,
                          des_senha: {
                            ...formConfiguracaoEmail.des_senha,
                            value,
                            isInvalid: value === '',
                          },
                        });
                      }

                      setFormConfiguracaoEmail({
                        ...formConfiguracaoEmail,
                        des_senha_entrada: {
                          ...formConfiguracaoEmail.des_senha_entrada,
                          value,
                          isInvalid: value === '',
                        },
                      });
                    }}
                  />

                  <ToggleEye
                    type="button"
                    onClick={togglePassword}
                    aria-label={
                      showPassword ? 'Ocultar senha' : 'Mostrar senha'
                    }
                    aria-pressed={showPassword}
                    title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                  >
                    {showPassword ? (
                      <FaRegEyeSlash size={16} />
                    ) : (
                      <FaRegEye size={16} />
                    )}
                  </ToggleEye>
                </FieldWrapper>
              </div>

              <div className="col-sm-12 col-md-2 d-flex justify-content-end">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  type="button"
                  style={{
                    marginTop: '30px',
                    height: '40px',
                  }}
                  onClick={testConfigEmailServidorEntrada}
                >
                  {emailServidorEntradaIsLoading ? (
                    <CircularProgress
                      size={15}
                      className="ml-5"
                      style={{ color: '#ffffff' }}
                    />
                  ) : (
                    <div>
                      <GiPlug
                        size={18}
                        style={{
                          marginRight: '5px',
                        }}
                      />
                      <span className="ml-5">Testar</span>
                    </div>
                  )}
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-12">
                <Separator labelText="Servidor de Saída" />
              </div>
            </div>

            <div className="row d-flex align-items-center">
              <div className="col-sm-12 col-md-3">
                <ToggleDefault
                  labelText="Usar Configurações de Entrada"
                  setChecked={
                    formConfiguracaoEmail.flg_configuracao_entrada.value
                  }
                  onSwitch={() => {
                    if (!formConfiguracaoEmail.flg_configuracao_entrada.value) {
                      setValue('des_email', getValues('des_email_entrada'));
                      setValue('des_senha', getValues('des_senha_entrada'));
                      setFormConfiguracaoEmail({
                        ...formConfiguracaoEmail,
                        des_email: {
                          ...formConfiguracaoEmail.des_email,
                          value: getValues('des_email_entrada'),
                        },
                        des_senha: {
                          ...formConfiguracaoEmail.des_senha,
                          value: getValues('des_senha_entrada'),
                        },
                      });
                    }

                    setFormConfiguracaoEmail({
                      ...formConfiguracaoEmail,
                      flg_configuracao_entrada: {
                        ...formConfiguracaoEmail.flg_configuracao_entrada,
                        value:
                          !formConfiguracaoEmail.flg_configuracao_entrada.value,
                      },
                    });
                  }}
                />
              </div>
              <div className="col-sm-12 col-md-11">
                <InputSelect
                  options={smtps as any[]}
                  label="SMTP"
                  control={control}
                  register={register}
                  name="cod_smtp"
                  placeholder="Selecione ou cadastre um novo SMTP"
                  isError={!!errors.cod_smtp}
                  changeSelected={(selected: any) => {
                    const value = {
                      label: selected?.label || 'Nenhum',
                      value: selected?.value || 0,
                    };

                    setValue('cod_smtp', value);

                    setFormConfiguracaoEmail({
                      ...formConfiguracaoEmail,
                      cod_smtp: {
                        ...formConfiguracaoEmail.cod_smtp,
                        value,
                        isInvalid: value.value === undefined,
                      },
                    });
                  }}
                />
              </div>

              <div className="col-sm-12 col-md-1 d-flex align-items-center justify-content-center gap-4 mt-4">
                <button
                  type="button"
                  className="btn-actions"
                  onClick={() => handleModalSmtp()}
                >
                  <FiPlusCircle size={24} color="#309063" />
                </button>
                {formConfiguracaoEmail?.cod_smtp?.value?.value &&
                formConfiguracaoEmail.cod_smtp.value.value !== 0 ? (
                  <button
                    type="button"
                    className="btn-actions"
                    onClick={() =>
                      handleModalSmtp(
                        formConfiguracaoEmail.cod_smtp.value.value,
                      )
                    }
                  >
                    <GoPencil size={24} color="#4c9aff" />
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-5">
                <InputText
                  label="Email"
                  placeholder="Digite aqui o email"
                  type="email"
                  maxLength={100}
                  disabled={
                    formConfiguracaoEmail.flg_configuracao_entrada.value
                  }
                  control={control}
                  register={register}
                  name="des_email"
                  isError={!!errors.des_email}
                  onInput={(ev: any) => {
                    const { value } = ev.target;

                    setValue('des_email', value);

                    setFormConfiguracaoEmail({
                      ...formConfiguracaoEmail,
                      des_email: {
                        ...formConfiguracaoEmail.des_email,
                        value,
                        isInvalid: value === '',
                      },
                    });
                  }}
                />
              </div>

              <div className="col-sm-12 col-md-5">
                <FieldWrapper>
                  <InputText
                    name="des_senha"
                    control={control}
                    isError={!!errors.des_senha}
                    register={register}
                    label="Senha"
                    type={showPasswords ? 'text' : 'password'}
                    placeholder={isUpdate ? '' : 'Digite aqui a senha'}
                    maxLength={50}
                    disabled={
                      formConfiguracaoEmail.flg_configuracao_entrada.value
                    }
                    onInput={(e: ChangeEvent<HTMLInputElement>) => {
                      const { value } = e.target;
                      setValue('des_senha', value);
                      setFormConfiguracaoEmail({
                        ...formConfiguracaoEmail,
                        des_senha: {
                          ...formConfiguracaoEmail.des_senha,
                          value,
                          isInvalid: value === '',
                        },
                      });
                    }}
                  />

                  <ToggleEye
                    type="button"
                    onClick={togglePasswords}
                    aria-label={
                      showPasswords ? 'Ocultar senha' : 'Mostrar senha'
                    }
                    aria-pressed={showPasswords}
                    title={showPasswords ? 'Ocultar senha' : 'Mostrar senha'}
                    disabled={
                      formConfiguracaoEmail.flg_configuracao_entrada.value
                    }
                  >
                    {showPasswords ? (
                      <FaRegEyeSlash size={16} />
                    ) : (
                      <FaRegEye size={16} />
                    )}
                  </ToggleEye>
                </FieldWrapper>
              </div>

              <div className="col-sm-12 col-md-2 d-flex justify-content-end">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  type="button"
                  style={{
                    marginTop: '30px',
                    height: '40px',
                  }}
                  onClick={testConfigSMTP}
                >
                  {smtpIsLoading ? (
                    <CircularProgress
                      size={15}
                      className="ml-5"
                      style={{ color: '#ffffff' }}
                    />
                  ) : (
                    <>
                      <GiPlug
                        size={18}
                        style={{
                          marginRight: '5px',
                        }}
                      />
                      <span className="ml-5">Testar</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </FormDefault>
        )}
      </Container>
    </>
  );
};

export default ConfiguracaoDeEmail;
